import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {ILwgSite} from "../../../../../../utils/interfaces/lwg_dashboard/reports/production/ILwgSite";


const useApiGetReportProductionByLwgSite = (): UseQueryResult<ILwgSite[], CustomAxiosError> => {
    const {selectedCompany} = useAuth()
    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<ILwgSite[]> {
        try {
            const response = await get(`/api/company/${company_token}/lwg_dashboard/lwg_reports/production/by_lwg_site`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetReportProductionByLwgSite"],
        queryFn: () => doGet(selectedCompany?.company_token),
    })


};

export default useApiGetReportProductionByLwgSite